import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";


export const JobWorkInwardPopup = (props) => {
    const itemColdefs = [
        {
            field: "jobWorkNo",
            headerName: "Job Work No",
            minWidth: window.innerWidth * 0.05,
            flex: 0.5,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "drawingNo",
            headerName: "Drawing No",
            minWidth: window.innerWidth * 0.09,
            flex: 0.8,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "searchText",
            headerName: "Search text",
            minWidth: window.innerWidth * 0.1,
            flex: 0.8,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "itemName",
            headerName: "Item details",
            minWidth: window.innerWidth * 0.2,
            flex: 2,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "size",
            headerName: "Size",
            minWidth: window.innerWidth * 0.06,
            flex: 0.6,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "quantity",
            headerName: "Quantity",
            minWidth: window.innerWidth * 0.06,
            flex: 0.6,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "inwardQty",
            headerName: "Inward Quantity",
            minWidth: window.innerWidth * 0.06,
            flex: 0.6,
            filter: true,
            floatingFilter: true,
            // editable: true,
            // cellClassRules: {
            //     'cell-error': (params) => {
            //         return (parseFloat(params.value) || 0) > (parseFloat(params.data.quantity) || 0);
            //     }
            // },
            // valueSetter: (params) => {
            //     const newValue = parseFloat(params.newValue) || 0;
            //     if (isNaN(newValue)) return false;

            //     params.data.inwardQty = newValue;

            //     props.calculateRowPricing(params.data);
            //     props.calculatePricing()
            //     return true;
            // }
        },
        // {
        //     field: "rejectQty",
        //     headerName: "Reject Qty",
        //     minWidth: window.innerWidth * 0.06,
        //     flex: 0.6,
        //     filter: true,
        // },
        {
            field: "pendingQty",
            headerName: "Pending Qty",
            minWidth: window.innerWidth * 0.06,
            flex: 0.6,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "rate",
            headerName: "Jobwork Rate",
            minWidth: window.innerWidth * 0.06,
            flex: 0.5,
            filter: true,
            floatingFilter: true,
            // editable: true,
            // valueSetter: (params) => {
            //     let newValue = params.newValue;

            //     params.data.rate = (newValue === "" || newValue === null || isNaN(newValue))
            //         ? 0
            //         : parseFloat(newValue);

            //     props.calculateRowPricing(params.data);
            //     props.calculatePricing();

            //     return true;
            // }
        },
        {
            field: "jwRate",
            headerName: "Rate",
            minWidth: window.innerWidth * 0.05,
            flex: 0.6,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "jwAmount",
            headerName: "Jobwork Amount",
            minWidth: window.innerWidth * 0.06,
            flex: 0.6,
            filter: true,
            floatingFilter: true,
            // editable: false,
            // valueGetter: (params) => {
            //     const qty = Number(params.data.inwardQty || 0);
            //     const jwRate = Number(params.data.jwRate || 0);
            //     let jwAmount = qty * jwRate;

            //     return jwAmount.toFixed(2);
            // }
        },
        {
            field: "amount",
            headerName: "Amount",
            minWidth: window.innerWidth * 0.06,
            flex: 0.6,
            filter: true,
            floatingFilter: true,
            // editable: false,
            // valueGetter: (params) => {
            //     const qty = Number(params.data.inwardQty || 0);
            //     const rate = Number(params.data.rate || 0);
            //     let amount = (qty * rate);
            //     return amount.toFixed(2);
            // }
        },
        {
            field: "discount",
            headerName: "Discount(%)",
            minWidth: window.innerWidth * 0.06,
            flex: 0.6,
            filter: true,
            floatingFilter: true,
            // editable: true,
            // valueSetter: (params) => {
            //     const newValue = params.newValue;
            //     params.data.discount = (newValue === "" || newValue === null || isNaN(newValue))
            //         ? 0
            //         : parseFloat(newValue);
            //     props.calculateRowPricing(params.data);
            //     props.calculatePricing()
            //     return true;
            // }
        },
        {
            field: "extraCharges",
            headerName: "Extra charges",
            minWidth: window.innerWidth * 0.06,
            flex: 0.6,
            filter: true,
            floatingFilter: true,
            // editable: true,
            // valueSetter: (params) => {
            //     let newValue = params.newValue;
            //     params.data.extraCharges = (newValue === "" || newValue === null || isNaN(newValue))
            //         ? 0
            //         : parseFloat(newValue);
            //     props.calculateRowPricing(params.data);
            //     props.calculatePricing()
            //     return true;
            // }
        },
        {
            field: "taxableAmt",
            headerName: "Taxable Amt",
            minWidth: window.innerWidth * 0.06,
            flex: 0.6,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "sgst",
            headerName: "SGST",
            minWidth: window.innerWidth * 0.05,
            flex: 0.5,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "sgstAmt",
            headerName: "SGST Amt",
            minWidth: window.innerWidth * 0.06,
            flex: 0.5,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "cgst",
            headerName: "CGST",
            minWidth: window.innerWidth * 0.05,
            flex: 0.5,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "cgstAmt",
            headerName: "CGST Amt",
            minWidth: window.innerWidth * 0.06,
            flex: 0.5,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "igst",
            headerName: "IGST",
            minWidth: window.innerWidth * 0.05,
            flex: 0.5,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "igstAmt",
            headerName: "IGST Amt",
            minWidth: window.innerWidth * 0.06,
            flex: 0.5,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "netTotal",
            headerName: "Net total",
            minWidth: window.innerWidth * 0.08,
            flex: 0.8,
            filter: true,
            floatingFilter: true,
            valueSetter: (params) => {
                props.calculateRowPricing(params.data);
                props.calculatePricing()
                return true;
            }
        },
        {
            field: "weight",
            headerName: "Weight",
            minWidth: window.innerWidth * 0.06,
            flex: 0.6,
            filter: true,
            editable: true,
            floatingFilter: true,
        },
        {
            field: "natureOfJobWork",
            headerName: "Nature of job work",
            minWidth: window.innerWidth * 0.08,
            flex: 0.8,
            filter: true,
            editable: true,
            floatingFilter: true,
        },
        {
            field: "remarks",
            headerName: "Remarks",
            minWidth: window.innerWidth * 0.08,
            flex: 0.8,
            filter: true,
            editable: true,
            floatingFilter: true,
        },
    ];

    const challanColdefs = [
        {
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 50,
            pinned: 'left',
            suppressSizeToFit: true
        },
        {
            field: "jobWorkNo",
            headerName: "Job work no",
            minWidth: window.innerWidth * 0.08,
            flex: 0.8,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "jobWorkFrom",
            headerName: "Job Work From",
            minWidth: window.innerWidth * 0.08,
            flex: 0.8,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "jobWorkDate",
            headerName: "Job work date",
            minWidth: window.innerWidth * 0.15,
            flex: 1.5,
            filter: true,
            floatingFilter: true,
        },

    ];

    const vendorColdefs = [
        {
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 50,
            pinned: 'left',
            suppressSizeToFit: true
        },
        {
            field: "itemName",
            headerName: "Item name",
            minWidth: window.innerWidth * 0.2,
            flex: 2,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "itemCategory",
            headerName: "Item category",
            minWidth: window.innerWidth * 0.08,
            flex: 0.6,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "quantity",
            headerName: "Quantity",
            minWidth: window.innerWidth * 0.05,
            flex: 0.8,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "sizeName",
            headerName: "Size name",
            minWidth: window.innerWidth * 0.1,
            flex: 1,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "itemRate",
            headerName: "Item rate",
            minWidth: window.innerWidth * 0.1,
            flex: 1,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "itemWeight",
            headerName: "Item weight",
            minWidth: window.innerWidth * 0.08,
            flex: 1,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "itemRateOn",
            headerName: "Item rate on",
            minWidth: window.innerWidth * 0.1,
            flex: 1,
            filter: true,
            floatingFilter: true,
        }
    ];
    return (
        <ModalBasic
            id="material-job-work"
            classParams="!w-[85%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            {!props.open && (
                <div className='input-fields p-[30px]'>
                    <span className="text-blue text-[16px] font-semibold">Details for job work inward</span>
                    <div className='item-grp grid grid-cols-5 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                        <div className='input-grp'>
                            <label>JobWork in no</label>
                            <TextInput type='text'
                                id='jobWorkInwardNo' name='jobWorkInwardNo'
                                value={props.materialObject.jobWorkInwardNo}
                                handleChange={(event) => props.handleChangeForWork(event, 'jobWorkInwardNo')}
                                className={props.validState?.error?.jobWorkInwardNo !== undefined ? "error" : ""}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Inward date</label>
                            <TextInput type='date'
                                id='jobWorkInwardDate' name='jobWorkInwardDate'
                                value={props.materialObject.jobWorkInwardDate}
                                handleChange={(event) => props.handleChangeForWork(event, 'jobWorkInwardDate')}
                                className={props.validState?.error?.jobWorkInwardDate !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Auth. employee</label>
                            {/* <MultiSelectDropdown
                                drpIdentity="Select employee"
                                options={props.employeeList}
                                value={props.materialObject.idEmployee ? props.employeeList.find(x => x.value === props.materialObject.idEmployee) : 0}
                                onChange={(event) =>
                                    props.setFilterParameters(event, "idEmployee")
                                }
                                className={props.validState?.error?.idEmployee !== undefined ? "error" : ""}
                            /> */}
                            <TextInput type='text'
                                id='usp_Users' name='usp_Users'
                                value={props.usp_Users.find(x => x.globalUserID === props.globalUserID)?.userName || ''}
                                disabled={true}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Testing no</label>
                            <TextInput type='text'
                                id='testingNo' name='testingNo'
                                value={props.materialObject.testingNo}
                                handleChange={(event) => props.handleChangeForWork(event, 'testingNo')}
                                className={props.validState?.error?.testingNo !== undefined ? "error" : ""}
                            />
                        </div>

                        <div className='input-grp'>
                            <label>Job work from</label>
                            <MultiSelectDropdown
                                drpIdentity="Select job work"
                                options={props.jobWorkFromLIst}
                                value={props.materialObject.idJobWorkFrom ? props.jobWorkFromLIst.find(x => x.value === props.materialObject.idJobWorkFrom) : 0}
                                onChange={(event) =>
                                    props.setFilterParameters(event, "idJobWorkFrom")
                                }
                                className={props.validState?.error?.idJobWorkFrom !== undefined ? "error" : ""}
                                isDisabled={true}
                            />

                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Gate pass</label>
                            <MultiSelectDropdown
                                drpIdentity="Select gatepass"
                                options={props.gatePassList}
                                value={props.materialObject.idGatepass ? props.gatePassList.find(x => x.value === props.materialObject.idGatepass) : 0}
                                onChange={(event) =>
                                    props.setFilterParameters(event, "idGatepass")
                                }
                                className={props.validState?.error?.idGatepass !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Outward no</label>
                            <TextInput type='text'
                                id='inwardNo' name='inwardNo'
                                value={props.materialObject.inwardNo}
                                handleChange={(event) => props.handleChangeForWork(event, 'inwardNo')}
                                className={props.validState?.error?.inwardNo !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Outward date</label>
                            <TextInput type='date'
                                id='inwardDate' name='inwardDate'
                                value={props.materialObject.inwardDate}
                                handleChange={(event) => props.handleChangeForWork(event, 'inwardDate')}
                                className={props.validState?.error?.inwardDate !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Supplier name</label>
                            <MultiSelectDropdown
                                drpIdentity="Select supplier"
                                options={props.partyAccountList}
                                value={props.materialObject.idVendor ? props.partyAccountList.find(x => x.value === props.materialObject.idVendor) : 0}
                                onChange={(event) =>
                                    props.setFilterParameters(event, "idVendor")
                                }
                                className={props.validState?.error?.idVendor !== undefined ? "error" : ""}
                            />

                        </div>
                        <div className='input-grp'>
                            <label>Inspection</label>
                            <TextInput type='text'
                                id='inspection' name='inspection'
                                value={props.materialObject.inspection}
                                handleChange={(event) => props.handleChangeForWork(event, 'inspection')}
                                className={props.validState?.error?.inspection !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Delivery</label>
                            <TextInput type='text'
                                id='deliveryCommence' name='deliveryCommence'
                                value={props.materialObject.deliveryCommence}
                                handleChange={(event) => props.handleChangeForWork(event, 'deliveryCommence')}
                                className={props.validState?.error?.deliveryCommence !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Transporter</label>
                            <TextInput type='text'
                                id='transporter' name='transporter'
                                value={props.materialObject.transporter}
                                handleChange={(event) => props.handleChangeForWork(event, 'transporter')}
                                className={props.validState?.error?.transporter !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='item-grp grid grid-cols-5 gap-2.5 col-span-5'>
                            <div className='input-grp row-span-2 col-span-2'>
                                <label>Address</label>
                                <textarea rows={4}
                                    id='address' name='address'
                                    value={props.materialObject.address}
                                    onChange={(event) => props.handleChangeForWork(event, 'address')}
                                    className={`h-full ${props.validState?.error?.address !== undefined ? "error" : ""}`}
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Inv. type</label>
                                <MultiSelectDropdown
                                    drpIdentity="Select inv"
                                    options={props.invTyleList}
                                    value={props.materialObject.idInv ? props.invTyleList.find(x => x.value === props.materialObject.idInv) : 0}
                                    onChange={(event) =>
                                        props.setFilterParameters(event, "idInv")
                                    }
                                    className={props.validState?.error?.idInv !== undefined ? "error" : ""}
                                />

                            </div>

                            <div className='input-grp'>
                                <label>Account head</label>
                                <MultiSelectDropdown
                                    drpIdentity="Select delivery"
                                    options={props.accountHeadList}
                                    value={props.materialObject.idGeneralProduct ? props.accountHeadList.find(x => x.value === props.materialObject.idGeneralProduct) : 0}
                                    onChange={(event) =>
                                        props.setFilterParameters(event, "idGeneralProduct")
                                    }
                                    className={props.validState?.error?.idGeneralProduct !== undefined ? "error" : ""}
                                />

                            </div>
                            <div className='input-grp'>
                                <label>Invoice no</label>
                                <TextInput type='text'
                                    id='invoiceNo' name='invoiceNo'
                                    value={props.materialObject.invoiceNo}
                                    handleChange={(event) => props.handleChangeForWork(event, 'invoiceNo')}
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Invoice date</label>
                                <TextInput type='date'
                                    id='invoiceDate' name='invoiceDate'
                                    value={props.materialObject.invoiceDate}
                                    handleChange={(event) => props.handleChangeForWork(event, 'invoiceDate')}
                                    className={props.validState?.error?.invoiceDate !== undefined ? "error" : ""}
                                />
                            </div>
                            <div className='btn-grp flex items-center gap-2.5 col-span-2 mt-5'>
                                <button className="save-btn btns py-[10px] px-[20px]" onClick={() => props.addJobWork("Insert")}>Add Job Work data</button>
                                {/* <button className="delete-btn btns py-[10px] px-[20px]" onClick={() => props.insert("Insert")}>Delete</button> */}
                            </div>
                        </div>
                        {props.materialObject.idMaterialJobWorkInward > 0 ?
                            <div className='col-span-3'>
                                <div className='btn-grp flex gap-2.5'>
                                    <button
                                        className="save-btn btns py-[10px] px-[20px] " onClick={() => props.downloadJobWorkInwardInvoice()}>Download Invoice
                                    </button>

                                    {/* <button
                                        className="save-btn btns py-[10px] px-[20px] " onClick={() => props.shareOnWhatsApp()}>Share On WhatsApp
                                    </button>

                                    <button
                                        className="save-btn btns py-[10px] px-[20px] " onClick={() => props.sendOnEmail()}>Send Email
                                    </button> */}
                                </div>
                            </div>
                            : null}
                    </div>
                    <span className="text-blue text-[16px] font-semibold">Item details</span>
                    <div className='item-grp grid grid-cols-6 gap-2.5 mt-3 mb-2 items-start'>
                        <div className='input-grp'>
                            <label>Drawing No</label>
                            <TextInput type='text'
                                id='drawingNo' name='drawingNo'
                                value={props.itemObject.drawingNo}
                                handleChange={(event) => props.handleChange(event, 'drawingNo')}
                                disabled
                            />
                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Item Detail</label>
                            <TextInput type='text'
                                id='itemName' name='itemName'
                                value={props.itemObject.itemName}
                                handleChange={(event) => props.handleChange(event, 'itemName')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Quantity</label>
                            <TextInput type='number'
                                id='quantity' name='quantity'
                                value={props.itemObject.quantity}
                                handleChange={(event) => props.handleChange(event, 'quantity')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Inward Quantity</label>
                            <TextInput type='number'
                                id='inwardQty' name='inwardQty'
                                value={props.itemObject.inwardQty}
                                handleChange={(event) => props.handleChange(event, 'inwardQty')}
                                className={props.validState?.error?.inwardQty !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Pending Qty</label>
                            <TextInput type='number'
                                id='pendingQty' name='pendingQty'
                                value={props.itemObject.pendingQty}
                                handleChange={(event) => props.handleChange(event, 'pendingQty')}
                                className={props.validState?.error?.pendingQty !== undefined ? "error" : ""}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Jobwork Rate</label>
                            <TextInput type='number'
                                id='rate' name='rate'
                                value={props.itemObject.rate}
                                handleChange={(event) => props.handleChange(event, 'rate')}
                                className={props.validState?.error?.rate !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Rate</label>
                            <TextInput type='number'
                                id='jwRate' name='jwRate'
                                value={props.itemObject.jwRate}
                                handleChange={(event) => props.handleChange(event, 'jwRate')}
                                className={props.validState?.error?.jwRate !== undefined ? "error" : ""}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Discount</label>
                            <TextInput type='number'
                                id='discount' name='discount'
                                value={props.itemObject.discount}
                                handleChange={(event) => props.handleChange(event, 'discount')}
                                className={props.validState?.error?.discount !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Extra Charges</label>
                            <TextInput type='number'
                                id='extraCharges' name='extraCharges'
                                value={props.itemObject.extraCharges}
                                handleChange={(event) => props.handleChange(event, 'extraCharges')}
                                className={props.validState?.error?.extraCharges !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Tax group</label>
                            <MultiSelectDropdown
                                drpIdentity="Select tax"
                                options={props.taxStructureList}
                                value={props.itemObject.idTaxGroup ? props.taxStructureList.find(x => x.value === props.itemObject.idTaxGroup) : 0}
                                onChange={(event) =>
                                    props.setFilterParameters(event, "idTaxGroup")
                                }
                                className={props.validState?.error?.idTaxGroup !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>SGST {props.itemObject.sgst !== '0.00' ? ' - ' + props.itemObject.sgst : ''}</label>
                            <TextInput type='text'
                                id='sgstAmt' name='sgstAmt'
                                value={props.itemObject.sgstAmt}
                                handleChange={(event) => props.handleChange(event, 'sgstAmt')}
                                className={props.validState?.error?.sgstAmt !== undefined ? "error" : ""}
                                disabled={true}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>CGST {props.itemObject.cgst !== '0.00' ? ' - ' + props.itemObject.cgst : ''}</label>
                            <TextInput type='text'
                                id='cgstAmt' name='cgstAmt'
                                value={props.itemObject.cgstAmt}
                                handleChange={(event) => props.handleChange(event, 'cgstAmt')}
                                className={props.validState?.error?.cgstAmt !== undefined ? "error" : ""}
                                disabled={true}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>IGST {props.itemObject.igst !== '0.00' ? ' - ' + props.itemObject.igst : ''}</label>
                            <TextInput type='text'
                                id='igstAmt' name='igstAmt'
                                value={props.itemObject.igstAmt}
                                handleChange={(event) => props.handleChange(event, 'igstAmt')}
                                className={props.validState?.error?.igstAmt !== undefined ? "error" : ""}
                                disabled={true}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Net total</label>
                            <TextInput type='number'
                                id='netTotal' name='netTotal'
                                value={props.itemObject.netTotal}
                                handleChange={(event) => props.handleChange(event, 'netTotal')}
                                className={props.validState?.error?.netTotal !== undefined ? "error" : ""}
                                disabled={true}
                            />
                        </div>
                        {/* <div className='input-grp'>
                            <label>Weight</label>
                            <TextInput type='number'
                                id='weight' name='weight'
                                value={props.itemObject.weight}
                                handleChange={(event) => props.handleChange(event, 'weight')}
                                className={props.validState?.error?.weight !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Nature of Job Work</label>
                            <TextInput type='text'
                                id='jobWork' name='jobWork'
                                value={props.itemObject.jobWork}
                                handleChange={(event) => props.handleChange(event, 'jobWork')}
                                className={props.validState?.error?.jobWork !== undefined ? "error" : ""}
                            />
                        </div> */}
                        <div className='input-grp col-span-1'>
                            <label>Remarks</label>
                            <TextInput type='text'
                                id='remarks' name='remarks'
                                value={props.itemObject.remarks}
                                handleChange={(event) => props.handleChange(event, 'remarks')}
                                className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='btn-grp flex gap-2.5 mt-5'>
                            <button
                                className="save-btn btns py-[10px] px-[20px]"
                                onClick={() => props.insertItem("Update")}
                            >
                                Update
                            </button>
                            <button
                                className="save-btn btns py-[10px] px-[20px]"
                                onClick={() => props.deleteItem()}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <div className="process-table h-[30vh] mt-5">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.itemRowData}
                                columnDefs={itemColdefs}
                                headerHeight={65}
                                onRowDoubleClicked={props.onItemRowDataClicked}
                                overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                onCellValueChanged={props.onCellValueChanged}
                                stopEditingWhenCellsLoseFocus={true}
                            />
                        </div>
                    </div>
                    <div className='total-amt mt-2.5 p-2.5 bg-[#3f8cff1a] rounded-[10px]'>
                        <span className="text-blue text-[16px] font-semibold">Amount details</span>
                        <div className='input-grp-outer grid grid-cols-8 gap-2.5 mt-2.5'>
                            <div className='input-grp'>
                                <label>Total quantity</label>
                                <TextInput type='number'
                                    id='totalQuantity' name='totalQuantity'
                                    value={props.materialObject.totalQuantity}
                                    handleChange={(event) => props.handleChangeForWork(event, 'totalQuantity')}
                                    disabled
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Total amount</label>
                                <TextInput type='number'
                                    id='totalAmt' name='totalAmt'
                                    value={props.materialObject.totalAmt}
                                    handleChange={(event) => props.handleChangeForWork(event, 'totalAmt')}
                                    disabled
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Extra charges</label>
                                <TextInput type='number'
                                    id='extraCharges' name='extraCharges'
                                    value={props.materialObject.extraCharges}
                                    handleChange={(event) => props.handleChangeForWork(event, 'extraCharges')}
                                    disabled
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Discount amount</label>
                                <TextInput type='number'
                                    id='discount' name='discount'
                                    value={props.materialObject.discount}
                                    handleChange={(event) => props.handleChangeForWork(event, 'discount')}
                                    disabled
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Taxable amount</label>
                                <TextInput type='number'
                                    id='taxableAmt' name='taxableAmt'
                                    value={props.materialObject.taxableAmt}
                                    handleChange={(event) => props.handleChangeForPayment(event, 'taxableAmt')}
                                    disabled
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Tax amount</label>
                                <TextInput type='number'
                                    id='taxAmt' name='taxAmt'
                                    value={props.materialObject.taxAmt}
                                    handleChange={(event) => props.handleChangeForWork(event, 'taxAmt')}
                                    disabled
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Total with tax</label>
                                <TextInput type='number'
                                    id='totalWithTax' name='totalWithTax'
                                    value={props.materialObject.totalWithTax}
                                    handleChange={(event) => props.handleChangeForWork(event, 'totalWithTax')}
                                    disabled
                                />
                            </div>
                            <div className='input-grp'>
                                <label>TCS amount</label>
                                <div className='input-inner flex items-center gap-[5px]'>
                                    <TextInput type='number'
                                        id='tcsPercentage' name='tcsPercentage'
                                        value={props.materialObject.tcsPercentage}
                                        handleChange={(event) => props.handleChangeForWork(event, 'tcsPercentage')}
                                        placeholder="%"
                                        className="w-[30%]"
                                    />
                                    <TextInput type='number'
                                        id='tcsAmt' name='tcsAmt'
                                        value={props.materialObject.tcsAmt}
                                        handleChange={(event) => props.handleChangeForWork(event, 'tcsAmt')}
                                        disabled
                                        className="w-[70%]"
                                    />
                                </div>
                            </div>
                            <div className='input-grp'>
                                <label>Adjustable amount</label>
                                <TextInput type='number'
                                    id='adjustableAmt' name='adjustableAmt'
                                    value={props.materialObject.adjustableAmt}
                                    handleChange={(event) => props.handleChangeForWork(event, 'adjustableAmt')}
                                    className='font-semibold'
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Final amount</label>
                                <TextInput type='number'
                                    id='finalAmt' name='finalAmt'
                                    value={props.materialObject.finalAmt}
                                    handleChange={(event) => props.handleChangeForWork(event, 'finalAmt')}
                                    className='font-semibold'
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        <button className="update-btn btns"
                            onClick={() => props.submit()} disabled={props.isSaving}>Save</button>
                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                        {props.permissions.isDelete && props.materialObject.idMaterialJobWorkInward ?
                            <button className="delete-btn btns" onClick={() => props.usp_Transaction_JobworkInwardDelete()}>Delete </button>
                            : null}
                    </div>
                </div>
            )}
            {props.open && (
                <div className='input-fields p-[30px]'>
                    <span className="text-blue text-[16px] font-semibold">Material job work inward selection</span>
                    <div className="process-table h-[35vh] mt-[5px] mb-2 pb-[8px] border-b border-slate-200">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.materialJobWorkInwardSelectionList}
                                columnDefs={challanColdefs}
                                onCellClicked={props.hanldeClickMaterialJobWorkInwardSelection}
                                // onGridReady={props.onGridReady}
                                rowSelection="multiple"
                                overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                onSelectionChanged={(event) => {
                                    const selectedRows = event.api.getSelectedRows();
                                    props.onSelectionChanged(selectedRows);
                                }}
                                onRowDataUpdated={(params) => {
                                    params.api.selectAll();
                                }}
                            />
                        </div>
                    </div>

                    <span className="text-blue text-[16px] font-semibold">Challan item details</span>
                    <div className="process-table h-[35vh] mt-[5px]">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.challanItemDetails}
                                columnDefs={vendorColdefs}
                                // onGridReady={props.onGridReady}
                                overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                rowSelection="multiple"
                                onSelectionChanged={(event) => {
                                    const selectedRows = event.api.getSelectedRows();
                                    props.onVendorSelectionChanged(selectedRows);
                                }}
                                onRowDataUpdated={(params) => {
                                    params.api.selectAll();
                                }}
                            />
                        </div>
                    </div>
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        <button className="update-btn btns" onClick={() => props.addProduct()}>Add products</button>
                        <button className="delete-btn btns" onClick={() => props.back()}>Back</button>
                    </div>
                </div>
            )}

        </ModalBasic>
    )
}